import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"padding":"20px"} }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { style: {"margin-bottom":"10px","color":"red","font-size":"14px"} }, " 说明：当前联系方式显示在客户系统中 ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_a_form, {
      model: $setup.contactFormState,
      ref: "contactFormRef",
      labelCol: { span: 4, offset: 0 }
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form_item, { name: "remark" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_textarea, {
              placeholder: "请输入备注",
              value: $setup.contactFormState.remark,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (($setup.contactFormState.remark) = $event)),
              rows: 6,
              maxlength: 100,
              "show-count": true,
              style: {"width":"600px"}
            }, null, 8, ["value"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, {
              type: "primary",
              onClick: $setup.confirmContact,
              loading: $setup.contactLoading
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 保存 ")
              ]),
              _: 1
            }, 8, ["onClick", "loading"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"])
  ]))
}